import React from "react";

function SidenavComponent() {
  return (
    <div className="sideNavigation">
      <div className="heading">
        <h4 className="headerdiv">Header</h4>
        <div className="text-div">Paracetamol Tablets</div>
        <div className="text-div">Paracetamol Syrup</div>
        <div className="text-div">Paracetamol Powder</div>
        <div className="btn-select-sidenav">
          Aceclofenac <l> &#10006;</l>
        </div>
        <div className="text-div">Acetaminophen or Paracetamol Tablets</div>
        <div className="text-div">Paracetamol Tablets</div>
      </div>
    </div>
  );
}

export default SidenavComponent;
